var echarts = require("../echarts");

var zrUtil = require("zrender/lib/core/util");

var barPolar = require("../layout/barPolar");

require("../coord/polar/polarCreator");

require("./angleAxis");

require("./radiusAxis");

require("./axisPointer");

require("./axisPointer/PolarAxisPointer");

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// For reducing size of echarts.min, barLayoutPolar is required by polar.
echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view

echarts.extendComponentView({
  type: 'polar'
});


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/polar.js
// module id = 386
// module chunks = 0